var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "swiper" } }, [
    _c(
      "div",
      { staticClass: "swipe-parent" },
      [
        _c(
          "swiper",
          { ref: "mySwiper", attrs: { options: _vm.swiperOptions } },
          _vm._l(_vm.swipeList, function(page, pageIdx) {
            return _c("swiper-slide", { key: "swipe-page" + pageIdx }, [
              _c(
                "div",
                {
                  staticClass: "swipe_image",
                  on: { mouseover: _vm.imageIn, mouseout: _vm.imageOut }
                },
                [
                  page.clickable
                    ? _c("img", {
                        staticClass: "clickable_bunner",
                        attrs: { src: _vm.getImage(page.img) },
                        on: {
                          click: function($event) {
                            _vm.goPage(page.route)
                          }
                        }
                      })
                    : _c("img", { attrs: { src: _vm.getImage(page.img) } })
                ]
              )
            ])
          })
        ),
        _vm._v(" "),
        _vm.swipeList.length
          ? [
              _c("div", {
                staticClass: "swiper-button-prev",
                style: _vm.swiperButtonPrev,
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-next",
                style: _vm.swiperButtonNext,
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6529cc58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6529cc58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/BannerSwiper.vue
// module id = null
// module chunks = 